import { Injectable, isDevMode } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { getModifaceConfig } from 'src/app/data/actions/modiface-config.actions';
import { getConf, getConfCustom } from 'src/app/data/actions/set-header.actions';
import { getConfPillReminder } from 'src/app/data/actions/set-pill-reminder-config.actions';
import { AlgoliaManager } from 'src/app/data/manager/algolia/algolia.manager';
import { BrazeManager } from 'src/app/data/manager/braze/braze.manager';
import { ConfigurationManager } from 'src/app/data/manager/configuration/configuration.manager';
import { SessionStorageManager } from 'src/app/data/manager/session-storage/session-storage.manager';
import { SasAlgoliaManager } from '../../data/manager-v3/sas-algolia/sas-algolia.manager';
import { SasCartManager } from '../../data/manager-v3/sas-subscription/sas-cart/sas-cart.manager';
import { CallCenterManager } from '../../data/manager/call-center/call-center.manager';
import { CartManager } from '../../data/manager/cart/cart.manager';
import { AddressManager } from '../../data/manager/customer/address/address.manager';
import { CustomerManager } from '../../data/manager/customer/customer/customer.manager';
import { FavoritesManager } from '../../data/manager/favorites/favorites.manager';
import { LocalStorageManager } from '../../data/manager/local-storage/local-storage.manager';
import { LocationManager } from '../../data/manager/location/location.manager';
import { UpdateCartEvent } from '../../ui/shared/event-listeners/update-cart/update-cart.event';
import { HeaderDepartmentsService } from '../../ui/shared/utilities/header-departments-service/header-departments.service';
import { OrderManager } from 'src/app/data/manager/order/order/order.manager';
import { ModifaceConfig } from 'src/app/data/networking/models/modiface/modiface-config';
import { FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';
import { FirebaseManager } from 'src/app/data/manager/firebase/firebase.manager';
import { GetPreviousOrdersBody, GetPreviousOrdersResponse } from 'src/app/data/networking/models/order/responses/order-res';

@Injectable({
  providedIn: 'root',
})
export class NavBarVm {
  constructor(private cartManager: CartManager,
              private addressManager: AddressManager,
              private customerManager: CustomerManager,
              private updateAgileCartEvent: UpdateCartEvent,
              private locationManager: LocationManager,
              private sasCartManager: SasCartManager,
              private sasAlgolia: SasAlgoliaManager,
              private ssm: SessionStorageManager,
              private lsm: LocalStorageManager,
              private callCenterManager: CallCenterManager,
              private configurationManager: ConfigurationManager,
              private favoritesManager: FavoritesManager,
              private _headerDepartmentsService: HeaderDepartmentsService,
              private algoliaManager: AlgoliaManager,
              private store: Store<AppState>,
              private brazeManager: BrazeManager,
              private orderManager: OrderManager,
              private firebaseManager: FirebaseManager,
            ) {
                this.getFacests();
              }

  getCart(): Observable<any> {
    return this.updateAgileCartEvent.updatedAgileCart;
  }

  getAgileCart(force?): Observable<any> {
    return this.cartManager.getAgile(force);
  }

  getAddresses(): Observable<any> {
    return this.addressManager.get();
  }

  hasCustomer(): Observable<any> {
    return this.customerManager.hasCustomer();
  }

  getCustomer() {
    return this.customerManager.customer;
  }

  getValidCustomer(): Observable<any> {
    const deliveryType = this.locationManager.getDeliveryType();
    if (deliveryType) {
      return this.customerManager.get({deliveryType});
    }
    return of(null);
  }

  getUserOrigin(data): Observable<any> {
    return this.customerManager.getCustomerOrigin(data);
  }

  logOut(): Observable<any> {
    return this.customerManager.logOut();
  }

  isSasEnabled() {
    return this.sasCartManager.isSasEnabled();
  }

  getFacests() {
    this.sasAlgolia.getFacets();
  }

  getSasCart(): Observable<any> {
    return this.sasCartManager.getCart();
  }

  getNavBarColor(item) {
    return this.ssm.get(item);
  }

  removeNavBarColor() {
    return this.ssm.removeItem('navColor');
  }

  callCenterCustomer() {
    return this.callCenterManager.getCustomer();
  }

  callCenterLogOut(): Observable<any> {
    return this.callCenterManager.logOut();
  }

  isLifeMilesEnabled() {
    return this.ssm.get('lifeMilesEnabled');
  }

  getConfigurationModules(): any {
    const conf = this.configurationManager.getConfigurationModule('general');
    if(isDevMode) { conf.cupon = true;}
    return conf;
  }

  getCountriesFtd(): Array<any> {
    return this.locationManager.getCountriesFtd();
  }

  getMainCountry(): any {
    return this.locationManager.getMainCountry();
  }

  getFavorites(): Observable<any> {
    return this.favoritesManager.get();
  }

  codeChagePassword(deleteCode?) {
    if (deleteCode) {
      this.customerManager.codeSmsChangePass = null;
    } else {
      return this.customerManager.codeSmsChangePass;
    }
  }

  getNavColorService(): Observable<any> {
    return this._headerDepartmentsService.getColor();
  }

  setIconCart(ico: string) {
    this._headerDepartmentsService.sendCartIcon(ico);
  }

  setNavColorService(color: string) {
    this._headerDepartmentsService.sendColor(color);
  }
  
  getSetColorsHeaderAlgolia( ids ){
    this.algoliaManager.getObjectsIdsByProperties( ids ).then( config => {
      this.store.dispatch( getConf( {data: config} ) );
    });
  }
  
  getSetColorsHeaderAlgoliaCustoms( ids ){
    this.algoliaManager.getObjectsIdsByProperties( ids ).then( config => {
      this.store.dispatch( getConfCustom( {dataCustom: config} ) );
    });
  }

  getPillReminderConfig(): void {
    this.algoliaManager.getPillReminderConfig().then(config => {
      this.store.dispatch(getConfPillReminder({data: config}));
    });
  }

  getModifaceConfig(): void {
    this.algoliaManager.getModifaceConfig().then(config => {
      this.store.dispatch(getModifaceConfig({data: config}));
    });
  }

  getGender(id): Observable<any> {
    return this.brazeManager.getGender(id);
  }

  getOrders(): Observable<any> {
    return this.orderManager.getOrders();
  }

  setFirstPurchaseValidate(data) {
    this.lsm.set( 'firstPurchaseValidate', data );
  }

  addProduct(id, fullPrice, mediaImageUrl, description, quantity ) {
    const dataAddProduct = {
      product: {
        id,
        mediaImageUrl,
        fullPrice,
        description
      },
      quantity: Number(quantity),
      action: 'add'
    };
    return this.cartManager.addProduct(dataAddProduct);
  }

  removeProduct(id) {
    const dataRemoveProduct = {
      product: {
        id
      }
    }
    return this.cartManager.removeProduct(dataRemoveProduct);
  }

  getRemoteConfig(): Observable<FirebaseFlags> {
    return this.firebaseManager.getRemoteConfig();
  }

  getAddress() {
    return this.addressManager.get();
  }

  setAddressDefault(address) {
    this.addressManager.setDeliveryAddress(address);
  }

  getPreviousOrders(data?: GetPreviousOrdersBody): Observable<GetPreviousOrdersResponse> {
    return this.orderManager.getPreviousOrders(data);
  }
}
